// extracted by mini-css-extract-plugin
export var cardIcon = "_6x-4";
export var checkboxCard = "_6x-0";
export var checkboxCardSelected = "_6x-3";
export var disabled = "_6x-1";
export var outerBorder = "_6x-2";
export var spacerMedium = "_6x-7";
export var spacerSmall = "_6x-6";
export var spacerXsmall = "_6x-5";